
import ChartsListPage from './charts-list/charts-list.js';
import ChartViewPage from './chart-view/chart-view.js';

export default [
	ChartsListPage,
	ChartViewPage	
];
